// Added changes by Gaurav Srivastava on 17-06-2024: Created a directive to safely render HTML content outside Angular's change detection mechanism.
import { Directive, ElementRef, Input, NgZone, OnChanges, SecurityContext, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[ngOutsideSafeHtml]',  // ✅ fixed typo (Outiside → Outside)
  standalone: false
})
export class OutsideSafeHtmlDirective implements OnChanges {
  @Input('ngOutsideSafeHtml') htmlContent!: string;

  constructor(
    private el: ElementRef<HTMLElement>,
    private sanitizer: DomSanitizer,
    private zone: NgZone
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!('htmlContent' in changes)) return;

    this.zone.runOutsideAngular(() => {
      const safeHtml = this.sanitizer.sanitize(SecurityContext.HTML, this.htmlContent) ?? '';
      this.el.nativeElement.innerHTML = safeHtml;
    });
  }
}
